export default function EmptyState({ icon = "📭", title, desc, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center px-4">
      <span className="text-5xl mb-4 opacity-60">{icon}</span>
      <p className="font-black text-lg text-gray-300">{title}</p>
      {desc && <p className="text-sm text-gray-500 mt-1 max-w-xs">{desc}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
